import { Service } from "../../../service.js";
import { env } from "../../../env.js";

class DashboardClienteService extends Service {
  constructor() {
    super();

    this.url = env.url + "status";
  }

  async getStatus() {
    const url = `${this.url}?isDashCliente=true`;
    return super.get(url);
  }
}

export const service = new DashboardClienteService();